import { render } from "./BombedPrivacyPolicy.vue?vue&type=template&id=21b0f832&scoped=true"
const script = {}

import "./BombedPrivacyPolicy.vue?vue&type=style&index=0&id=21b0f832&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b0f832"]])

export default __exports__